export const MAPS_KEY = process.env.REACT_APP_MAPS_KEY || '';
export const MAP_ID   = process.env.REACT_APP_MAP_ID   || '';
